import * as yup from 'yup';

const DEFAULT_MESSAGE = 'Este campo es requerido.';

const loginYup = yup.object().shape({
    email: yup.string().email('Escriba un email válido').required(DEFAULT_MESSAGE),
    password: yup.string()
});

export { loginYup };
